"use client";

import { c as _c } from "react/compiler-runtime";
import { Col, Row, Table } from "react-bootstrap";
import styles from "./LatestActivity.module.scss";
import LatestActivityRow from "./LatestActivityRow";
import { areEqualAddresses, isNextgenContract } from "@/helpers/Helpers";
import { normalizeNextgenTokenID } from "../nextGen/nextgen_helpers";
import type { Transaction } from "@/entities/ITransaction";
import type { NFT } from "@/entities/INFT";
import type { NextGenCollection } from "@/entities/INextgen";
interface ActivityTableProps {
  readonly activity: Transaction[];
  readonly nfts: NFT[];
  readonly nextgenCollections: NextGenCollection[];
}
export default function ActivityTable(t0) {
  const $ = _c(6);
  const {
    activity,
    nfts,
    nextgenCollections
  } = t0;
  let t1;
  if ($[0] !== activity || $[1] !== nextgenCollections || $[2] !== nfts) {
    t1 = activity && nfts && activity.map(tr => {
      let nft = undefined;
      let nextgenCollection = undefined;
      if (isNextgenContract(tr.contract)) {
        const normalized = normalizeNextgenTokenID(tr.token_id);
        nextgenCollection = nextgenCollections.find(c => c.id === normalized.collection_id);
      } else {
        nft = nfts.find(n => n.id === tr.token_id && areEqualAddresses(n.contract, tr.contract));
      }
      return <LatestActivityRow nft={nft} nextgen_collection={nextgenCollection} tr={tr} key={`${tr.from_address}-${tr.to_address}-${tr.transaction}-${tr.token_id}`} />;
    });
    $[0] = activity;
    $[1] = nextgenCollections;
    $[2] = nfts;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <Row className={`pt-3 ${styles.scrollContainer}`}><Col><Table bordered={false} className={styles.activityTable}><tbody>{t1}</tbody></Table></Col></Row>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}